import { ColorSource, Graphics } from 'pixi.js';

export const drawBorder = (
  x: number,
  y: number,
  width: number,
  height: number,
  color: ColorSource
) => {

  // Create new border graphics
  const borderGraphics = new Graphics();

  borderGraphics.lineStyle(3, color, 1);
  borderGraphics.beginFill(color, 0);
  borderGraphics.drawRect(x, y, width, height);
  borderGraphics.endFill();
  return borderGraphics;
};
